import { doShowModal, doHideModal } from 'actions/modals'
import { CHANGE_USER } from 'constants/modal_types'

export const doShowChangeUserModal = offset =>
  doShowModal(CHANGE_USER, { offset })

export const doHideChangeUserModal = () => doHideModal(CHANGE_USER)
